import { z } from "zod";

const Banregio3DSStatusType = z.enum([
  "Pendiente",
  "Aprobado",
  "Declinado",
  "Rechazado",
  "Timeout",
  "Fallido",
]);
const Banregio3DSResponseSchema = z
  .object({
    url_threeds: z.string(),
    estatus: Banregio3DSStatusType,
  })
  .transform((api) => ({
    url3D: api.url_threeds,
    status: api.estatus,
  }));

type Banregio3DSResponse = z.infer<typeof Banregio3DSResponseSchema>;
type Banregio3DSStatus = z.infer<typeof Banregio3DSStatusType>;

export {
  Banregio3DSResponseSchema,
  type Banregio3DSResponse,
  type Banregio3DSStatus,
};
